export const preparationResources = {
  fr: {
    card: {
      task: "Prélèvement",
      age: "Ancienneté",
      description: "Désignation",
      quantity: "Quantité à prélever",
      source: "Emplacement source",
      target: "Point de dépose",
      hu: "Unité logistique source (HU)",
      client: "Client",
      destination: "Destination finale",
      order: "Ordre de sortie",
      line: "Ligne de sortie",
      reference: "Référence externe",
      preparation: "Ordre de préparation",
      wave: "Vague"
    },
    module: "Picking", searchPlaceholder: "Tâche, HU, article…",
    searchWide: "Tâche, ordre, article, HU, emplacement ou gare",
    tabs: { open: "À préparer", progress: "En cours", alerts: "Alertes", closed: "Terminées" },
    tabsMobile: { open: "À FAIRE", progress: "EN COURS", alerts: "ALERTES", closed: "TERMINÉES" },
    actions: {
      new: "Nouvelle préparation", newShort: "Prépa.", createWave: "Créer une vague",
      waveShort: "Vague", take: "Prendre en charge", execute: "Exécuter", confirm: "Confirmer",
      viewAlert: "Consulter l’alerte", select: "Sélectionner", view: "Consulter",
      pickingList: "Liste de prélèvement", createTasks: "Créer les tâches",
      createWaveConfirm: "Créer la vague", reportProblem: "Signaler un problème",
      confirmPicking: "Confirmer le prélèvement", confirmTake: "Confirmer la prise en charge",
      prepareOutputHu: "Préparer la HU de prélèvement",
      reserveReturnableHu: "Réserver cette HU retournable",
      viewOutputHuDocument: "Consulter le document HU",
      requestFefoException: "Demander une dérogation FEFO",
      saveAlert: "Enregistrer l’alerte", cancelRelease: "Annuler et libérer",
      correctPartialPicking: "Corriger le prélèvement", confirmCorrection: "Confirmer la correction"
    },
    fefo: {
      blocked: "Ce prélèvement est bloqué par un contrôle FEFO. Une dérogation motivée peut être soumise à un responsable.",
      reason: "Motif de la demande de dérogation",
      submitted: "Une demande de dérogation FEFO est déjà en attente. Le prélèvement reste bloqué jusqu’à sa décision."
    },
    labels: {
      preparationTour: "Tournée de préparation", picks: "{{count}} prélèvement", picks_other: "{{count}} prélèvements",
      outboundOrders: "{{count}} ordre de sortie", outboundOrders_other: "{{count}} ordres de sortie",
      priority: "priorité {{priority}}", step: "étape {{current}}/{{total}}",
      routeStep: "Étape {{step}}",
      freeOrder: "ordre libre, parcours recommandé", client: "Client {{client}}",
      route: "Parcours :", distance: "distance {{distance}} u", returnDistance: "retour {{distance}} u",
      sequence: "séquence {{sequence}}", undefined: "non définie", available: "Disponible",
      upcoming: "À venir", outboundOrder: "Ordre de sortie {{number}}", line: "ligne {{line}}",
      pickingStep: "Picking {{number}}", waveStep: "Vague {{number}}",
      createOrderDialog: "Créer un ordre de préparation", reservedAllocation: "Allocation réservée",
      consolidationStation: "Gare de consolidation", priorityField: "Priorité",
      createWaveDialog: "Créer une vague de préparation", preparations: "{{count}} préparation", preparations_other: "{{count}} préparations",
      tasks: "{{count}} tâche", tasks_other: "{{count}} tâches", deliveryBefore: "à livrer avant {{date}}",
      orderLine: "Ligne {{line}}", huTasks: "{{count}} HU/tâche", currentSelection: "Sélection actuelle : {{preparations}}, {{tasks}}, {{articles}}.",
      articles: "{{count}} article", articles_other: "{{count}} articles", wavePriority: "Priorité de la vague",
      handlingEquipment: "Moyen de manutention", load: "charge {{load}}", capacity: "capacité {{capacity}}",
      picking: "Prélèvement", hu: "HU", item: "Article", quantity: "Quantité", routeField: "Parcours",
      pickedQuantity: "Quantité prélevée", exceptionType: "Type d’exception",
      sourceHu: "HU stock", preparationHu: "HU de préparation",
      stockBefore: "avant {{quantity}} {{uom}}", stockRemaining: "reste {{quantity}} {{uom}}",
      transferredQuantity: "{{quantity}} {{uom}} transféré(s)", fullHuTransferred: "HU complète transférée",
      exceptionComment: "Commentaire d’exception", resolutionComment: "Commentaire de résolution",
      noEquipment: "Pas de moyen nécessaire", reversePartialTitle: "Corriger un prélèvement partiel",
      correctionReason: "Motif de correction"
    },
    help: {
      groupingDisabled: "Le regroupement est désactivé dans Paramètres > Préparation.",
      minimumPicks: "Au moins deux prélèvements ouverts et non regroupés sont nécessaires.",
      waveDisabled: "La création de vague est désactivée dans Paramètres > Préparation. Les prélèvements peuvent être exécutés individuellement.",
      waveInstructions: "Sélectionnez les ordres de sortie à regrouper. Une vague peut contenir plusieurs ordres ou un seul ordre comportant plusieurs prélèvements. Le serveur contrôle ensuite les critères actifs dans Paramètres > Préparation.",
      equipmentLoading: "Recherche des moyens adaptés…",
      equipmentChoose: "Choisissez un moyen dans la liste ou scannez/saisissez un identifiant compatible.",
      equipmentNone: "Aucun moyen n’est proposé actuellement ; vous pouvez scanner un identifiant qui vient d’être libéré.",
      selectPreparations: "Sélectionnez d’abord les préparations.",
      directEquipment: "Choisissez, saisissez ou scannez le moyen utilisé pour ce prélèvement direct.",
      scanTask: "Scannez l’emplacement source, puis la HU. Confirmez ensuite la quantité réellement prélevée.",
      outputHuPrepared: "HU de prélèvement préparée : {{number}}",
      preparingOutputHu: "Préparation de la HU de prélèvement…",
      derogatedLotVisualCheck: "Lot sous dérogation de péremption : effectuez un contrôle visuel du produit avant de confirmer le prélèvement.",
      compatibleEquipment: "Choisissez un moyen compatible ou scannez/saisissez son identifiant.",
      requiredThree: "Obligatoire — minimum 3 caractères",
      reversePartial: "{{output}} sera clôturée et son contenu sera réintégré dans {{source}}. La tâche repassera en cours pour être confirmée à nouveau."
    },
    scan: { sourceLocation: "Scanner l’emplacement source", hu: "Scanner la HU", outputHu: "Scanner la HU de prélèvement" },
    exceptions: {
      STOCK_NOT_FOUND: "Stock absent", QUANTITY_MISMATCH: "Quantité incorrecte",
      HU_DAMAGED: "HU endommagée", LOCATION_INACCESSIBLE: "Emplacement inaccessible"
    },
    age: { minutes: "arrivée depuis {{minutes}} min", hours: "arrivée depuis {{hours}} h {{minutes}} min", days: "arrivée depuis {{days}} j {{hours}} h" },
    print: {
      popupBlocked: "Autorisez les fenêtres contextuelles pour éditer la liste de prélèvement.",
      title: "Liste de prélèvement {{wave}}", heading: "Liste de prélèvement · {{wave}}",
      print: "Imprimer", warehouse: "Entrepôt", destination: "Destination", priority: "Priorité",
      equipment: "Moyen", location: "Emplacement", item: "Article", quantity: "Quantité", check: "Contrôle"
    },
    aria: { hidePicks: "Masquer les prélèvements", showPicks: "Afficher les prélèvements" },
    empty: { list: "Aucune tâche dans cette liste.", allocations: "Aucune allocation ouverte n’est disponible.", stations: "Aucune gare de consolidation picking active pour cet entrepôt." },
    errors: {
      load: "Impossible de charger les préparations.", takeWave: "La vague n’a pas pu être prise en charge.",
      create: "Création impossible.", equipment: "Impossible de déterminer les moyens de manutention adaptés.",
      createWave: "Création de la vague impossible.", availableEquipment: "Impossible de charger les moyens disponibles.",
      action: "Action impossible.",
      documentUnavailable: "Le document de la HU n’est pas encore disponible. Réessayez dans quelques secondes."
    }
  },
  en: {
    card: {
      task: "Picking task",
      age: "Age",
      description: "Description",
      quantity: "Quantity to pick",
      source: "Source location",
      target: "Drop-off point",
      hu: "Source handling unit (HU)",
      client: "Customer",
      destination: "Final destination",
      order: "Outbound order",
      line: "Outbound line",
      reference: "External reference",
      preparation: "Preparation order",
      wave: "Wave"
    },
    module: "Picking", searchPlaceholder: "Task, HU, material…",
    searchWide: "Task, order, material, HU, location or station",
    tabs: { open: "To prepare", progress: "In progress", alerts: "Alerts", closed: "Completed" },
    tabsMobile: { open: "TO DO", progress: "IN PROGRESS", alerts: "ALERTS", closed: "COMPLETED" },
    actions: {
      new: "New preparation", newShort: "Prep.", createWave: "Create wave",
      waveShort: "Wave", take: "Resume", execute: "Execute", confirm: "Confirm",
      viewAlert: "View alert", select: "Select", view: "View",
      pickingList: "Picking list", createTasks: "Create tasks", createWaveConfirm: "Create wave",
      reportProblem: "Report a problem", confirmPicking: "Confirm picking",
      prepareOutputHu: "Prepare picking HU",
      reserveReturnableHu: "Reserve this returnable HU",
      viewOutputHuDocument: "View HU document",
      requestFefoException: "Request FEFO exception",
      confirmTake: "Confirm take-over", saveAlert: "Save alert", cancelRelease: "Cancel and release",
      correctPartialPicking: "Correct picking", confirmCorrection: "Confirm correction"
    },
    fefo: {
      blocked: "This pick is blocked by a FEFO control. A justified exception may be submitted for approval.",
      reason: "Exception request reason",
      submitted: "A FEFO exception request is already pending. Picking remains blocked until a decision is made."
    },
    labels: {
      preparationTour: "Preparation tour", picks: "{{count}} pick", picks_other: "{{count}} picks",
      outboundOrders: "{{count}} outbound order", outboundOrders_other: "{{count}} outbound orders",
      priority: "priority {{priority}}", step: "step {{current}}/{{total}}",
      routeStep: "Step {{step}}",
      freeOrder: "free order, recommended route", client: "Customer {{client}}",
      route: "Route:", distance: "distance {{distance}} u", returnDistance: "return {{distance}} u",
      sequence: "sequence {{sequence}}", undefined: "not defined", available: "Available",
      upcoming: "Upcoming", outboundOrder: "Outbound order {{number}}", line: "line {{line}}",
      pickingStep: "Picking {{number}}", waveStep: "Wave {{number}}",
      createOrderDialog: "Create preparation order", reservedAllocation: "Reserved allocation",
      consolidationStation: "Consolidation station", priorityField: "Priority",
      createWaveDialog: "Create preparation wave", preparations: "{{count}} preparation", preparations_other: "{{count}} preparations",
      tasks: "{{count}} task", tasks_other: "{{count}} tasks", deliveryBefore: "deliver before {{date}}",
      orderLine: "Line {{line}}", huTasks: "{{count}} HU/task", currentSelection: "Current selection: {{preparations}}, {{tasks}}, {{articles}}.",
      articles: "{{count}} material", articles_other: "{{count}} materials", wavePriority: "Wave priority",
      handlingEquipment: "Handling equipment", load: "load {{load}}", capacity: "capacity {{capacity}}",
      picking: "Picking", hu: "HU", item: "Material", quantity: "Quantity", routeField: "Route",
      pickedQuantity: "Picked quantity", exceptionType: "Exception type",
      sourceHu: "Stock HU", preparationHu: "Preparation HU",
      stockBefore: "before {{quantity}} {{uom}}", stockRemaining: "{{quantity}} {{uom}} remaining",
      transferredQuantity: "{{quantity}} {{uom}} transferred", fullHuTransferred: "Full HU transferred",
      exceptionComment: "Exception comment", resolutionComment: "Resolution comment",
      noEquipment: "No equipment required", reversePartialTitle: "Correct partial picking",
      correctionReason: "Correction reason"
    },
    help: {
      groupingDisabled: "Grouping is disabled in Settings > Preparation.",
      minimumPicks: "At least two open, ungrouped picks are required.",
      waveDisabled: "Wave creation is disabled in Settings > Preparation. Picks can be executed individually.",
      waveInstructions: "Select the outbound orders to group. A wave can contain multiple orders or one order with multiple picks. The server then checks the active criteria in Settings > Preparation.",
      equipmentLoading: "Searching for suitable equipment…", equipmentChoose: "Choose equipment from the list or scan/enter a compatible identifier.",
      equipmentNone: "No equipment is currently proposed; you can scan an identifier that has just been released.",
      selectPreparations: "Select preparations first.", directEquipment: "Choose, enter or scan the equipment used for this direct pick.",
      scanTask: "Scan the source location, then the HU. Then confirm the quantity actually picked.",
      outputHuPrepared: "Picking HU prepared: {{number}}",
      preparingOutputHu: "Preparing the picking HU…",
      derogatedLotVisualCheck: "Shelf-life derogated lot: visually inspect the product before confirming the pick.",
      compatibleEquipment: "Choose compatible equipment or scan/enter its identifier.", requiredThree: "Required — at least 3 characters",
      reversePartial: "{{output}} will be closed and its contents restored to {{source}}. The task will return to in progress so it can be confirmed again."
    },
    scan: { sourceLocation: "Scan source location", hu: "Scan HU", outputHu: "Scan picking HU" },
    exceptions: {
      STOCK_NOT_FOUND: "Stock not found", QUANTITY_MISMATCH: "Quantity mismatch",
      HU_DAMAGED: "Damaged HU", LOCATION_INACCESSIBLE: "Inaccessible location"
    },
    age: { minutes: "arrived {{minutes}} min ago", hours: "arrived {{hours}} h {{minutes}} min ago", days: "arrived {{days}} d {{hours}} h ago" },
    print: {
      popupBlocked: "Allow pop-up windows to edit the picking list.", title: "Picking list {{wave}}",
      heading: "Picking list · {{wave}}", print: "Print", warehouse: "Warehouse", destination: "Destination",
      priority: "Priority", equipment: "Equipment", location: "Location", item: "Material", quantity: "Quantity", check: "Check"
    },
    aria: { hidePicks: "Hide picks", showPicks: "Show picks" },
    empty: { list: "No task in this list.", allocations: "No open allocation is available.", stations: "No active picking consolidation station is available for this warehouse." },
    errors: {
      load: "Unable to load preparations.", takeWave: "The wave could not be taken over.", create: "Unable to create.",
      equipment: "Unable to determine suitable handling equipment.", createWave: "Unable to create the wave.",
      availableEquipment: "Unable to load available equipment.", action: "Action failed.",
      documentUnavailable: "The HU document is not available yet. Try again in a few seconds."
    }
  }
} as const;
